<div fxLayout="row wrap" fxLayout.xs="column wrap" fxLayoutAlign="start start">
  @for (item of taskItems; track item) {
    <mat-card
      fxFlex.gt-xs="50%"
      fxFlex.gt-md="32%"
      style="margin-top: 3px; margin-right: 3px;flex-grow: 0;flex-basis: 0;width:fit-content;"
      [class.mat-elevation-z7]='true'>
      <mat-card-title style="font-size: 16px; font-weight: 500; width: 220px;height: 30px; ">
        {{item.name}}
      </mat-card-title>
      @if (item.statusCode === 700000000) {
        <div style="margin-top: 6px;">
          <div fxHide.gt-sm fxShow.lt-md style="height: 100px; width: 220px; background-color: #f6f6f6;">
            @if (waitForFileToUpload[lookupIndex(item)] === false) {
              <img
                [src]="promptUploadImage" alt="{{'waiting for upload: ' + item.name}}"
                style="height: 100px; width:100px; display: block; margin: auto;"/>
            }
          </div>
          @if (waitForFileToUpload[lookupIndex(item)] !== false && fileError !== true) {
            <div style="margin-top: 25px;">
              <mat-progress-bar mode="indeterminate" style="width: 100%;"></mat-progress-bar>
            </div>
          }
          <div>
            @if ((checkUploadAuthorization(item) === 1 || checkUploadAuthorization(item) === 2)) {
              <div>
                @if (checkUploadAuthorization(item) === 1) {
                  <p
                    style="margin-bottom: 6px;">
                    Submitted to EBB
                  </p>
                }
                @if (checkUploadAuthorization(item) === 2) {
                  <p
                    style="margin-top: 12px; margin-bottom: 12px;">
                    READ-ONLY
                  </p>
                }
                @if (checkUploadAuthorization(item) === 1 && item.statusCode !== 700000001) {
                  <p
                    style="margin-top: 11px; margin-bottom: 12px;">
                    NO ACTION REQUIRED
                  </p>
                }
                @if (checkUploadAuthorization(item) === 1 && item.statusCode === 700000001) {
                  <p
                    style="margin-top: 11px; margin-bottom: 12px;">
                    APPROVED
                  </p>
                }
              </div>
            } @else {
              <div  fxHide.gt-sm fxShow.lt-md  >
                <p style="margin-top: 14px; margin-bottom: 6px;">
                  Please submit a photo
                </p>
              </div>
              @if (waitForFileToUpload[lookupIndex(item)] === false) {
                <div fxShow.gt-sm fxHide.lt-md  (click)="onUploadPhotoEvent(item)" class="col-12 rmpm" style=" min-height: 100px;min-width: 200px;display: table;width: 100%;background-color: #eee; border: dotted 1px #aaa;" appDrag (files)="filesDropped($event,item)">
                  <div class="text-wrapper">
                    <img
                      [src]="promptUploadImage" alt="{{'waiting for upload: ' + item.name}}"
                      style="height: 100px; width:100px; display: block; margin: auto;"/>
                      <div style="text-align: center;"> Drop image here or click to upload</div>
                    </div>
                  </div>
                }
               
              <div style="display: inline-block;">
                @if (waitForFileToUpload[lookupIndex(item)] === false) {
                  <button mat-raised-button color="primary"
                    id="{{formatNameToId(item.name)}}-upload"
                    (click)="onUploadPhotoEvent(item)" style="font-size: 12px;">
                    UPLOAD PHOTO
                  </button>
                }
                @if (checkcookie(item.id)) {
                  <p  fxShow.gt-sm fxHide.lt-md class="mat-error"><mat-icon>warning</mat-icon> {{getCookie(item.id)}}</p>
                }
              </div>
              @if (item.isRequired === false) {
                <div style="display: inline-block;  float: right;margin-right: 4px;">
                  @if (waitForFileToUpload[lookupIndex(item)] === false) {
                    <button  mat-raised-button color="primary"
                      id="{{formatNameToId(item.name)}}-upload-notneed"
                      (click)="onUploadNAPhotoEvent(item)" style="font-size: 12px;">
                      NOT NEEDED
                    </button>
                  }
                </div>
              }
            }
            @if (waitForFilesToShow===true) {
              <span>
                UPLOADING...
              </span>
            }
          </div>
        </div>
      } @else {
        @if (item.statusCode === 700000001) {
          <div >
            <div class="text-wrapper">
              <a href="javascript:void(0)" (click)="onViewFileEvent(2, item.id)">
                @if (lookupSubmittedPhoto(item.payload).fileShow) {
                  <img
                    src="{{lookupSubmittedPhoto(item.payload).file}}"  alt="{{'photo for ' + item.name}}"
                    style="max-height:100px; max-width:240px; display: block; margin: auto;"/>
                }
              </a>
            </div>
          </div>
        }
        @if (!waitForFilesToShow && checkUploadAuthorization(item) === 3 && item.statusCode !== 700000001) {
          <div
            style="margin-top: 6px; height: 102px; width: 220px; background-color: #f6f6f6; border:#29637C; border-width: 1px; border-style: solid;">
            <div   (click)="onUploadPhotoEvent(item)" class="col-12 rmpm" style=" min-height: 100px;min-width: 200px;display: table;width: 100%;background-color: #eee; border: dotted 1px #aaa;" appDrag (files)="filesDropped($event,item)">
              <div class="text-wrapper">
                <a href="javascript:void(0)" (click)="onViewFileEvent(2, item.id)">
                  @if (lookupSubmittedPhoto(item.payload).fileShow) {
                    <img
                      src="{{lookupSubmittedPhoto(item.payload).file}}"  alt="{{'photo for ' + item.name}}"
                      style="max-height:100px; max-width:240px; display: block; margin: auto;"/>
                  }
                </a>
              </div>
            </div>
          </div>
        }
        @if (waitForFileToUpload[lookupIndex(item)] === false && checkUploadAuthorization(item) !== 3 && item.statusCode !== 700000001) {
          <div
            style="margin-top: 6px; height: 102px; width: 220px; background-color: #f6f6f6; border:#29637C; border-width: 1px; border-style: solid;">
            <a href="javascript:void(0)" (click)="onViewFileEvent(2, item.id)">
              @if (lookupSubmittedPhoto(item.payload).fileShow) {
                <img
                  src="{{lookupSubmittedPhoto(item.payload).file}}"  alt="{{'photo for ' + item.name}}"
                  style="max-height:100px; max-width:240px; display: block; margin: auto;"/>
              }
            </a>
          </div>
        }
        @if (waitForFileToUpload[lookupIndex(item)] !== false) {
          <div style="margin-top: 25px;">
            <mat-progress-bar mode="indeterminate" style="width: 100%;"></mat-progress-bar>
          </div>
        }
        @if ((checkUploadAuthorization(item) === 1 || checkUploadAuthorization(item) === 2)
          ) {
          <div
            >
            <div style="margin-top: 12px;">
              @if (checkUploadAuthorization(item) === 1) {
                <p
                  style="margin-bottom: 6px;">
                  Submitted to EBB
                </p>
              }
              <div [ngClass]="'buttonAlignContainer'">
                @if (checkUploadAuthorization(item) === 2) {
                  <div style="height: 36px; padding-top: 9px; font-size: 14px;"
                    style="margin-top: 12px; margin-bottom: 12px;">
                    READ-ONLY
                  </div>
                }
                @if (checkUploadAuthorization(item) === 1 && item.statusCode !== 700000001) {
                  <div style="height: 36px; padding-top: 9px; font-size: 14px;"
                    >
                    NO ACTION REQUIRED
                  </div>
                }
                @if (checkUploadAuthorization(item) === 1 && item.statusCode === 700000001) {
                  <div style="height: 36px; padding-top: 9px; font-size: 14px;"
                    >
                    APPROVED
                  </div>
                }
                @if (item.ebbModifiedByTypeOptionSet && item.ebbModifiedDate) {
                  <button
                    matTooltip="{{item.ebbModifiedByTypeOptionSet}} Update, Date: {{item.ebbModifiedDate | date:'MM/dd/yyyy':'PST'}}"
                    mat-icon-button aria-label="Upload information" color="primary"
                    style="height: 24px; width: 24px;">
                    <mat-icon style="font-size: 24px; margin-top: -18px;">info</mat-icon>
                  </button>
                }
              </div>
            </div>
          </div>
        } @else {
          <div
            style="margin-top: 12px;">
            @switch (item.statusCode) {
              @case (700000001) {
                <div>
                  <p style="margin-bottom: 6px;">
                    {{item.statusCodeOptionSet}} by EBB
                  </p>
                  <div [ngClass]="'buttonAlignContainer'">
                    <button mat-flat-button>
                      NO ACTION REQUIRED
                    </button>
                    @if (item.ebbModifiedByTypeOptionSet && item.ebbModifiedDate) {
                      <button
                        matTooltip="{{item.ebbModifiedByTypeOptionSet}} Update, Date: {{item.ebbModifiedDate | date:'MM/dd/yyyy':'PST'}}"
                        mat-icon-button aria-label="Upload information" color="primary"
                        style="height: 24px; width: 24px;">
                        <mat-icon style="font-size: 24px; margin-top: -18px;">info</mat-icon>
                      </button>
                    }
                  </div>
                </div>
              }
              @case (700000002) {
                <div>
                  <p class="warn-text" style="margin-bottom: 6px;">
                    Action required
                    @if (item.reasonWhy) {
                      <span style="color: black">
                        (<a style='color: #29637C; font-size: 16px; font-weight: 400;'
                        href="javascript:void(0)"
                      (click)='onClickShowReasonWhy(item.reasonWhy)'>read why</a>)
                    </span>
                  }
                </p>
                <div [ngClass]="'buttonAlignContainer'">
                  <button mat-stroked-button color="primary"
                    id="{{formatNameToId(item.name)}}-uploadreplacement"
                    (click)="onUploadPhotoEvent(item)">
                    UPLOAD REPLACEMENT
                  </button>
                  @if (item.ebbModifiedByTypeOptionSet && item.ebbModifiedDate) {
                    <button
                      matTooltip="{{item.ebbModifiedByTypeOptionSet}} Update, Date: {{item.ebbModifiedDate | date:'MM/dd/yyyy':'PST'}}"
                      mat-icon-button aria-label="Upload information" color="primary"
                      style="height: 24px; width: 24px;">
                      <mat-icon style="font-size: 24px; margin-top: -18px;">info</mat-icon>
                    </button>
                  }
                </div>
                @if (checkcookie(item.id)) {
                  <p  fxShow.gt-sm fxHide.lt-md class="mat-error"><mat-icon>warning</mat-icon> {{getCookie(item.id)}}</p>
                }
              </div>
            }
            @case (700000003) {
              <div>
                <p style="margin-bottom: 6px;">
                  Waiting for review by EBB
                </p>
                <div [ngClass]="'buttonAlignContainer'">
                  <button mat-stroked-button color="primary"
                    id="{{formatNameToId(item.name)}}-uploadreplacement"
                    (click)="onUploadPhotoEvent(item)">
                    UPLOAD REPLACEMENT
                  </button>
                  @if (item.ebbModifiedByTypeOptionSet && item.ebbModifiedDate) {
                    <button
                      matTooltip="{{item.ebbModifiedByTypeOptionSet}} Update, Date: {{item.ebbModifiedDate | date:'MM/dd/yyyy':'PST'}}"
                      mat-icon-button aria-label="Upload information" color="primary"
                      style="height: 24px; width: 24px;">
                      <mat-icon style="font-size: 24px; margin-top: -18px;">info</mat-icon>
                    </button>
                  }
                </div>
                @if (checkcookie(item.id)) {
                  <p  fxShow.gt-sm fxHide.lt-md class="mat-error"><mat-icon>warning</mat-icon> {{getCookie(item.id)}}</p>
                }
              </div>
            }
          }
        </div>
      }
    }
  </mat-card>
}
</div>
